import React, { useState } from 'react';
import classnames from 'classnames';
import ListHeader from 'components/ListComponents/ListHeader';
import Label from 'components/form/Label/Label';
import NegativeMarksAccountsItem from '../NegativeMarksAccountsItem/NegativeMarksAccountsItem';

const ListNegativeMarksAccounts = props => {
  const [listExpanded, setListExpanded] = useState(false);

  return (
    <div className={classnames('listContainer')}>
      <ListHeader
        accounts={props?.accounts}
        headerText={`See your ${props?.totalNegativeMarks} negative ${
          props?.totalNegativeMarks > 1 ? 'marks' : 'mark'
        } `}
        numAccounts={props?.totalNegativeMarks}
        hideCount
        iconClass=""
        onClick={() => {
          setListExpanded(!listExpanded);
        }}
        isListExpanded={listExpanded}
      />
      {listExpanded ? (
        <>
          <Label type="Body-2">
            Negative marks listed on your Trans Union credit report.
          </Label>
          <NegativeMarksAccountsItem accounts={props?.accounts} type="simple" />
        </>
      ) : null}
    </div>
  );
};

export default ListNegativeMarksAccounts;
